module.exports = __webpack_public_path__ + "media/honey-icons/icon-flow-high-f393ec54.svg";